import { render, staticRenderFns } from "./TagTemplate.vue?vue&type=template&id=9763a09e&scoped=true&"
import script from "./TagTemplate.vue?vue&type=script&lang=js&"
export * from "./TagTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9763a09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9763a09e')) {
      api.createRecord('9763a09e', component.options)
    } else {
      api.reload('9763a09e', component.options)
    }
    module.hot.accept("./TagTemplate.vue?vue&type=template&id=9763a09e&scoped=true&", function () {
      api.rerender('9763a09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TagTemplate.vue"
export default component.exports